import commonHelpers from './common-helpers';

const setCookie = (name, value, exdays, domain, secure) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;${secure && window.location.protocol === 'https' ? 'secure' : ''}`;
  // document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; domain=${domain}; path=/ ; ${secure ? 'secure' : ''}`;
};

const getCookie = (name) => {
  if (!name) { return null; }
  return decodeURIComponent(document.cookie.replace(new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(name).replace(/[\-\.\+\*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')) || null;
};

const deleteCookie = (name) => {
  if (getCookie(name)) {
    const expires = `expires=${new Date(0)}`;
    document.cookie = `${name}=;${expires};path=/`;
  }
};

const verifyValidOAUser = (role) => {
  
  let cookieUserName = process.env.NODE_ENV === 'production'? "prod_user" : "staging_user";

  const user = JSON.parse(getCookie(cookieUserName));
  if (user) {
    const isValidUser = user
      && user.name
      && user.name.length
      && user.email
      && user.email.length
      && user.userId
      && commonHelpers.isValidGuid(user.token)
      && commonHelpers.isValidGuid(user.key);

    const rolesListLower = (user.rolesList || '').toLowerCase();
    const canViewDashboard = rolesListLower.indexOf('admin') > -1 || 
                             rolesListLower.indexOf('ResearchUser') > -1 || 
                             rolesListLower.indexOf('accountmanager') > -1 ||
                             (role && rolesListLower.indexOf(role) > -1);
    
    return isValidUser && canViewDashboard;
  }
  return false;
};

export default { setCookie, getCookie, deleteCookie, verifyValidOAUser };
